/**
 * Lab golive Surveillance graph generate / view types.
 * Rate JSON keys: `…/{runnerId}.json` | `…INPLAY.json` | `…INPLAYOFF.json`
 * (see Backend-UI `changeGraphTypeView` + Sportsbook `graphTypeParam`).
 */

import type { SurveillanceMode, SurveillanceRunner } from './types'

export type SurveillanceGraphViewType = 'NORMAL' | 'INPLAY' | 'INPLAYOFF'

export type GraphTypeOption = {
  value: SurveillanceGraphViewType
  label: string
}

/** Live surveillance-betlist: Full → Inplay → Before Inplay */
export const GENERATE_GRAPH_OPTIONS: Record<SurveillanceMode, GraphTypeOption[]> = {
  live: [
    { value: 'NORMAL', label: 'Full' },
    { value: 'INPLAY', label: 'Inplay' },
    { value: 'INPLAYOFF', label: 'Before Inplay' },
  ],
  /** Beta / archive: Inplay → Before Inplay → Full */
  archive: [
    { value: 'INPLAY', label: 'Inplay' },
    { value: 'INPLAYOFF', label: 'Before Inplay' },
    { value: 'NORMAL', label: 'Full' },
  ],
}

/** Same labels as generate; order follows Lab page (live vs beta). */
export const APPLY_GRAPH_VIEW_OPTIONS = GENERATE_GRAPH_OPTIONS

export function defaultGraphViewType(mode: SurveillanceMode): SurveillanceGraphViewType {
  return mode === 'archive' ? 'INPLAY' : 'NORMAL'
}

/** Lab strips INPLAYOFF before INPLAY so "INPLAYOFF" is not left as "INPLAY" + "OFF". */
export function applyGraphViewTypeToUrl(
  url: string,
  viewType: SurveillanceGraphViewType,
): string {
  let next = url.replaceAll('INPLAYOFF', '').replaceAll('INPLAY', '')
  if (viewType === 'INPLAY' || viewType === 'INPLAYOFF') {
    next = next.replace('.json', `${viewType}.json`)
  }
  return next
}

export function applyGraphViewTypeToRunners(
  runners: SurveillanceRunner[],
  viewType: SurveillanceGraphViewType,
): SurveillanceRunner[] {
  return runners.map((r) => ({
    ...r,
    u: applyGraphViewTypeToUrl(r.u, viewType),
    fu: applyGraphViewTypeToUrl(r.fu, viewType),
  }))
}
